// extracted by mini-css-extract-plugin
export var chip = "_dc-0";
export var filterDropdown = "_dc-5";
export var filterItem = "_dc-6";
export var icon = "_dc-1";
export var removeButton = "_dc-3";
export var removeIcon = "_dc-4";
export var separator = "_dc-2";